import { Injectable, signal } from '@angular/core';

export interface BreadcrumbItem {
  label: string;
  routerLink?: string[]; // se assente, è foglia
}

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  breadcrumbs = signal<BreadcrumbItem[]>([]);

  setItems(breadcrumbs: BreadcrumbItem[]) {
    this.breadcrumbs.set(breadcrumbs);
  }
}
